// extracted by mini-css-extract-plugin
export default {"payment-breakdown":"wY7fi","title":"iIvs1","label-value":"xBzSW","label-value--bold":"TQ1Hs","label":"gJrhs"};